import { Typography, Grid2 } from '@mui/material'
import { Link } from 'react-router-dom'
import CommonNodeLoginForm from './CommonNodeLoginForm';

const StudentLoginForm= () => {

    const bottomLine = (
        <Grid2 children size={12} display={"flex"} justifyContent={"center"}>
            <Typography variant='body2' fontSize={"12px"}>If you don't have an account !! </Typography>  <Link to={"/StudentSignUp"}><Typography variant='body2' fontSize={"12px"} color='red.main'> Sign Up</Typography></Link>
        </Grid2>
    );


     return <CommonNodeLoginForm role={"student"} bottomLine={bottomLine} loginRoute={"collab-login"} />
    
}

export default StudentLoginForm




















